import { createSelector } from 'reselect'
import { map, get, values, filter, isEmpty, find, includes, replace } from 'lodash'
import { getConfiguration, getConfigurations } from 'store/Configurations/selector'

export const getPrinters = (state) => values(get(state, ['printers', 'byId'], []))

export const getUsbBluetoothTcpPrinters = createSelector(getPrinters, (printers) =>
  filter(printers, (printer) => ['TCP', 'USB', 'Bluetooth'].includes(printer.connection)),
)

export const getPrinter = (state, uuid) => {
  const configurations = getConfigurations(state)
  const printer = get(state, ['printers', 'byId', uuid], {})

  const configurationWithAssociatedPrinter = find(configurations, (configuration) => {
    const controlledPrinterUuids = configuration?.configuration?.controlledPrinterUuids ?? []
    return includes(controlledPrinterUuids, printer.uuid)
  })

  const configurationsWithSetReceiptPrinterName = filter(configurations, (configuration) => {
    return configuration.configuration?.receiptPrinterUuid === printer.uuid
  })

  const configurationControlledPrinters = configurationWithAssociatedPrinter?.configuration ?? []

  const port = replace(printer.port, 'TCP:', '')

  return {
    ...printer,
    port,
    configurationControlledPrinters,
    configurationsWithSetReceiptPrinterName,
    configurationWithAssociatedPrinter,
    configuration: [
      {
        label: configurationWithAssociatedPrinter?.name ?? '',
        value: configurationWithAssociatedPrinter?.uuid ?? '',
      },
    ],
  }
}

export const getSelectablePrinters = (state, uuid) => {
  // get Receipt Printer Name set in configuration
  const chosenReceiptPrinterUuid = get(
    getConfiguration(state, uuid),
    'configuration.receiptPrinterUuid',
  )
  const chosenReceiptPrinter = getPrinter(state, chosenReceiptPrinterUuid)
  const chosenReceiptPrinterFormated = {
    label: get(chosenReceiptPrinter, 'name'),
    value: get(chosenReceiptPrinter, 'uuid'),
  }

  // get printers which are set to display in Receipt Printer Name
  // and their uuid field is not empty
  const receiptPrinters = filter(
    getPrinters(state),
    (printer) => printer.receiptPrinter === true && !isEmpty(printer.uuid),
  )

  const selectedPrinters = map(receiptPrinters, (printer) => ({
    label: printer.name,
    value: printer.uuid,
  }))

  // check if printer is set as Receipt Printer Name option
  // if it set as Receipt Printer Name, but it was toggled off in Printer settings
  // it will be still displayed in this specific configuration but not in others
  // if any other option will be selected - this printer, which is not
  // set as Receipt Printer Name option will disappear
  const isPrinterSetAsReceipt = map(receiptPrinters, (printer) => printer.uuid).includes(
    chosenReceiptPrinterUuid,
  )

  if (isPrinterSetAsReceipt || isEmpty(chosenReceiptPrinterUuid)) {
    return selectedPrinters
  } else {
    return [...selectedPrinters, chosenReceiptPrinterFormated]
  }
}

export const getPrinterFilters = (state, filter) => state?.printers?.filters[filter]
